<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div
        style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 220px);  height: calc(100vh - 60px);overflow: auto;">
        <div class="edit">
            <div class="fl" style="justify-content: space-between; margin-left: 6px">
              <span style="width: 69px; display: block"  @click="cleanUpEvt">ALL</span>
            </div>
          <el-tooltip class="item" effect="dark" content="选择年" placement="top-start">
            <el-date-picker v-model="value0" type="year" placeholder="选择年" style="width: 137px;margin-left: 6px;"
              @change="getList" size="mini" format="yyyy-MM-dd" range-separator="" value-format="timestamp">
            </el-date-picker>
          </el-tooltip>

            <el-tooltip class="item" effect="dark" content="结算部门" placement="top-start">
              <el-select v-model="jsbm" filterable placeholder="结算部门" @change="jsbmChange"
                style="margin-left: 6px;" clearable >
                   <el-option v-for="(value, key) in jsbm_one" :key="key" :label="value.name" :value="value.id">
                </el-option>
              </el-select>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="请选择" placement="top-start">
                  <el-cascader @change="Customer_type" v-model="state" popper-class='custom_box' placeholder="请选择"
                    :options="options1" filterable clearable >
                  </el-cascader>
                </el-tooltip>
                  <span style="margin-left: 5px"  @click="excelEvt">EXCEL</span>
        </div>
        <div class="pagination_box">
            <span>总产值：{{ totalRow_one.division }}</span>
            <span>总回款金额：{{ totalRow_one.backed_amount }}</span>
            <span>总雇佣成本：{{ totalRow_one.employment }} </span>
            <span>总工作量：{{ totalRow_one.quantities }}</span>
            <span>单位工作量产值：{{ totalRow_one.unit_division }}</span>
            <span>单位工作量成本：{{ totalRow_one.unit_employment }}</span>
            <span>成本产值比 &nbsp;{{ totalRow_one.division_employment }}%</span>
          </div>
        <div class="table_one"  >
          <table    class="layui-table" >
              <thead>
              <tr class="order-flexs th_one" >
                  <th></th>
                  <th >产值</th>
                  <th >回款金额</th>
                  <th >雇佣成本</th>
                  <th >成本产值比</th>
                  <th >当月工作量</th>
                  <th v-for="(val, index) in staff"   :key="index"    >
                    {{ val}}
                  </th>
              </tr>
              </thead>
              <tbody  >
              <tr class="order-flexs">
                  <td style="font-size: 14px;width: 120px;">总雇佣成本</td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                    <td  v-for="(val, index) in employment" :key="index" :style="{ color: val == '0' ? '#e9e9e9' : '#000', }">
                      {{ val }}
                    </td>
              </tr>
                  <tr class="order-flexs">
                    <td style="font-size: 14px;width: 120px;">到手工资</td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                    <td ></td>
                      <td  v-for="(val, index) in payable" :key="index" :style="{ color: val == '0' ? '#e9e9e9' : '#000', }">
                        {{ val }}
                      </td>
                </tr>
              <tr class="order-flexs">
                  <td style="font-size: 14px;width: 120px;">总工作量</td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td  v-for="(val, index) in quantities" :key="index" :style="{ color: val == '0' ? '#e9e9e9' : '#000', }">
                    {{ val }}
                  </td>
              </tr>
              <tr class="order-flexs">
                  <td style="font-size: 14px;width: 120px;">单位工作量工资</td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td ></td>
                  <td v-for="(val, valIndex) in unit_salary" :key="valIndex"  :style="{ color: val == '0' ? '#e9e9e9' : '#000', }">
                      {{ val }}
                    </td>
              </tr>
              <tr class="order-flexs order" v-for="(val, valIndex) in month" :key="valIndex">
                  <td> {{ valIndex }}月</td>
                  <td :style="{ color: tableData.division[valIndex] == '0' ? '#d8eeff' : '#000', }">{{ tableData.division[valIndex] }}</td>
                  <td :style="{ color: tableData.backed_month[valIndex] == '0' ? '#d8eeff' : '#000', }">{{ tableData.backed_month[valIndex] }}</td>
                  <td  :style="{ color: tableData.employmentMonth[valIndex] == '0' ? '#d8eeff' : '#000', }">{{ tableData.employmentMonth[valIndex] }}</td>
                  <td :style="{ color: tableData.divEmp[valIndex] == '0' ? '#d8eeff' : '#000', }">{{ tableData.divEmp[valIndex] }}%</td>
                  <td :style="{ color: tableData.quantities_month[valIndex] == '0' ? '#d8eeff' : '#000', }">{{ tableData.quantities_month[valIndex] }}</td>
                  <td v-for="(item, index) in val" :key="index"  :style="{ color: item == '0' ? '#EAF6FF' : '#000', }"  >{{ item }}</td>
              </tr>

              </tbody>
          </table>
        </div>
      </div>
    </el-main>


  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { OrderApi,   SearchApi } from "@/api/salary/index.js"


export default {
  components: {
    GlobalHeader
  },
  computed: {

  },
  data() {

    return {
      activeIndex: "4-2",
      tableData: [],
      totalRow_one:[],
      employment:[],
      staff:[],
      quantities:[],
      unit_salary:[],
      payable:[],
      month:[],
      value0: '',
       options1: [{
        value: 'employment',
        label: '雇佣成本',
      }, {
        value: 'payable',
        label: '到手工资',
      }, {
        value: 'quantities',
        label: '总工作量',
      }],
      state:'',

      jsbm_one:null,
      jsbm:null,
    };
  },
  created() {
    OrderApi().then(res => {
      this.tableData = res.data
      this.staff  = res.data.staff
      this.employment  = res.data.employment
      this.quantities  = res.data.quantities
      this.unit_salary =res.data.unit_salary
      this.payable = res.data.payable
      this.month = res.data.month
      this.totalRow_one = res.data.total
    })
    SearchApi().then(res=>{
       this.jsbm_one = res.data.jsbm
    })
  },
  mounted() {
  },
  methods: {
    //排序
    array_sum: function (obj) {
      let sum = 0;
      for (let key in obj) {
        sum += parseInt(obj[key])
      }
      return sum;
    },
    sum_avg: function (a, b) {
      b = Array.from(b).reduce((sum, value) => sum + value, 0);
      a = Array.from(a).reduce((sum, value) => sum + value, 0);
      if (b !== 0) {
        return a / b;
      }
      return 0;
    },
    Customer_type(selectedValues) {
      this.state = selectedValues[0];
      this.getList();
    },

    jsbmChange(value) {
      this.jsbm = value;
      this.getList()
    },
    getList() {
      if (this.value0 !== null) {
        // 执行您的逻辑
        let date4 = {
          start: this.value0[0],
          end: this.value0[1],
        };
        var income_time_start = Math.floor(this.value0 / 1000);
      }
      let data = {
        start: income_time_start ? income_time_start:'',
        state:this.state,
        jsbm: this.jsbm,
      }
      OrderApi(data).then(res => {
        this.tableData = res.data
        this.staff = res.data.staff
        this.employment = res.data.employment
        this.quantities = res.data.quantities
        this.unit_salary = res.data.unit_salary
        this.payable=res.data.payable
        this.month = res.data.month
        this.totalRow_one = res.data.total
      })
    },
    excelEvt() {
       let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      var income_time_start = Math.floor(this.value0 / 1000);
      let data = {
        start: income_time_start ? income_time_start : '',
        state: this.state,
        jsbm: this.jsbm,
        excel: 1,
      }
      this.loading = true
      let genExcel = false;
      if (genExcel == false) {
        OrderApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }
    },




     cleanUpEvt() {
      this.state = '';
      this.value0 = '';
      this.jsbm = ''
      OrderApi().then((res => {
         this.tableData = res.data
        this.staff = res.data.staff
        this.employment = res.data.employment
        this.quantities = res.data.quantities
        this.unit_salary = res.data.unit_salary
        this.payable = res.data.payable
        this.month = res.data.month
        this.totalRow_one = res.data.total
      }))
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../style/Media_Query.less");

.el-main {
  left: 185px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}




.edit {
  // width: 1000px;
  height: 40px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}

.view_box {
  display: flex;
  justify-content: end;

  .el-dropdown {
    margin-top: 8px;
    margin-right: 10px
  }

  span {
    border: 1px solid #e5e5e5;
    padding: 5px 20px;
    margin-top: 10px;
    border-radius: 3px;
  }
}


.table_one {
  display: flex;
}

.table_two {
  margin: 10px 0;
}

.order-flexs{
  display: flex;
  margin-top:-2px ;
  th{
    width: 91px;
  }
}
.order-flexs th:nth-child(1){
  width: 120px;
}
thead .th_one{
  th{
    background-color:#e9e9e9 ;
    border: 1px solid #d1d1d1;
    border-bottom: none;
    font-size: 14px;
    font-weight: 500;
    padding: 11px  0;
  }
}
tbody .order-flexs{
  display: flex;
  background-color:#e9e9e9;
  border-top: none;
  th{
    width: 120px;
    border: 1px solid #e9e9e9;
  }
  td{
    width: 91px;
    border: 1px solid #d1d1d1;
    padding: 11px  0;
    font-size: 12px;
  }
}
.order{
  td:not(:first-child){
  }
   td:nth-child(n+2):nth-child(-n+6){
    background-color: #d8eeff;
  }
   td:not(:first-child):not(:nth-child(n+2):nth-child(-n+6)){
    background-color: #EAF6FF;
  }
}

.pagination_box {
  display: flex;
  justify-content: flex-start;
  min-width: 500px;
  font-size: 14px;
  cursor: pointer;
  span{
    padding:10px 20px;
  }
}
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}
/deep/.el-icon-date:before{
  content : '',
}

/deep/.order td:nth-child(1){
  width:120px;
}
</style>
<style>
.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/src/salary_management/Annual_salary/index.vue